export default __webpack_public_path__ + "static/media/safety.dfb07647.svg";